import { Router } from "@angular/router";
import {
  HttpErrorResponse,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { AuthService } from "./auth.service";
import { catchError, filter, finalize, switchMap, take } from "rxjs/operators";
import { BehaviorSubject, Observable, throwError } from "rxjs";

@Injectable()
export class KalemHttpInterceptor implements HttpInterceptor {
  isRefreshingToken: boolean;
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  static addToken(req: HttpRequest<any>, token: string) {
    return req.clone({ setHeaders: { Authorization: "Bearer " + token } });
  }

  constructor(
    private router: Router,
    private injector: Injector,
    private authService: AuthService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return next
      .handle(KalemHttpInterceptor.addToken(req, AuthService.getAuthToken()))
      .pipe(
        catchError((err) => {
          if (err instanceof HttpErrorResponse) {
            switch ((<HttpErrorResponse>err).status) {
              case 403:
                return this.handle403Error(req, next);
              case 401:
                return AuthService.logout(() => {
                  return this.router.navigateByUrl("/auth/login");
                });
              case 400:
                return throwError(err);
              default:
                return throwError(err);
            }
          } else {
            return throwError(err);
          }
        })
      );
  }

  handle403Error(req, next) {
    if (!this.isRefreshingToken) {
      this.isRefreshingToken = true;
      this.tokenSubject.next(null);
      return this.authService.refreshToken().pipe(
        switchMap((response) => {
          if (response.access_token) {
            const newToken = response.access_token;
            this.tokenSubject.next(newToken);
            return next.handle(KalemHttpInterceptor.addToken(req, newToken));
          } else {
            return this.logoutUser();
          }
        }),
        catchError(() => {
          return this.logoutUser();
        }),
        finalize(() => {
          this.isRefreshingToken = false;
        })
      );
    } else {
      return this.tokenSubject.pipe(
        filter((token) => token !== null),
        take(1),
        switchMap((token) => {
          return next.handle(KalemHttpInterceptor.addToken(req, token));
        })
      );
    }
  }

  logoutUser() {
    AuthService.logout(() => {
      this.router.navigateByUrl("/auth/login");
    });
    return throwError("");
  }
}
